import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=04a616e0&scoped=true&"
import script from "./DownloadSection.vue?vue&type=script&lang=js&"
export * from "./DownloadSection.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSection.vue?vue&type=style&index=0&id=04a616e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a616e0",
  null
  
)

export default component.exports